import styled from 'styled-components';

export const PolicyStyle = styled.div`
  margin-bottom: 60px;

  .tabs {
    background-color: #fafafb;
    position: fixed;
    width: 100%;
    height: 60px;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 16px;

    .tab {
      cursor: pointer;
      user-select: none;
      border: none;
      outline: none;
      background-color: transparent;
      padding: 0;
      margin: 0;

      &.active {
        font-weight: 600;
      }
    }
  }
`;
